import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../Button/Button";
import "../../assets/css/custom.scss"
import "./index.css";
import HeaderJourney from '../../storybook/Header/HeaderJourney';
import { isNullOrUndefined, detectMobile } from "../../utils/formatting";
import * as api from "../../api";
import "../GenericError/index.css";
import { CatalistTriageContractorType } from "../../models/Repair/Contractor";
import { RepairPriority } from "../../models/Repair/CreateRepair";
import { userChosenPropertyType, userGetRepairData, setWorkOrderApiFailureMessage } from "../../ducks/redux/actions/userChoices";


const WorkOrderErrorPage: React.FC<any> = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    enum EmergencySelection {
        "SelectedEmergencyTypeYes" = "Yes, I can provide access",
        "SelectedEmergencyTypeNo" = "No, I can provide access",
      }

    const workOrderObject = useSelector(
        (state: any) => state?.addresses?.workOrderRepair
    );

    const determinedcontractordetails = useSelector(
        (state: any) => state.addresses?.determinedcontractordetails
    );

    const priority = useSelector(
        (state: any) =>
            state?.dashboardReducer?.formState?.selectedRepairReasonObject[0]
                ?.priority
    );

    const userChosenEmergencyQuestion = useSelector(
        (state: any) => state?.userChoicesReducer?.userChosenEmergencyQuestion
    );

    const selectedproperty = useSelector(
        (state: any) => state?.userChoicesReducer?.userChosenPropertyType
    );

    const isMobile = detectMobile();

    const openMobiledialer = () => {
        window.open('tel:' + t('phone_no'));
    };

    const returnToHomeButtonHandler = () => {
        dispatch(setWorkOrderApiFailureMessage(true));
        props.history.push("/customer360View")
    };

    const refreshButtonHandler = async () => {
        let jobNumber = "";
        const contractorDetail = determinedcontractordetails?.[0];
        const contractorSiteOnHoldCase = contractorDetail?.contractorSites?.[0] === CatalistTriageContractorType.CONTRACTORSITE_ON_HOLD
        if (!isNullOrUndefined(workOrderObject.id)) {
            const repair = (await api.getRepair(workOrderObject.id));
            dispatch(userGetRepairData(repair));
            jobNumber = repair?.jobNo;
            if (jobNumber) {
                const appointmentWillNotBeCreated = contractorSiteOnHoldCase ||
                    priority === RepairPriority.Emergency ||
                    userChosenEmergencyQuestion === EmergencySelection.SelectedEmergencyTypeYes ||
                    contractorDetail?.statuses?.isEMA ||
                    !contractorDetail?.statuses?.isIntegrated ||
                    contractorDetail?.statuses?.isBuilder;
                if (appointmentWillNotBeCreated) {
                    dispatch(userChosenPropertyType(repair.area));
                    dispatch(userGetRepairData(""));
                    dispatch(setWorkOrderApiFailureMessage(false));
                    props.history.push("/customer360View");
                } else {
                    dispatch(userChosenPropertyType(repair.area));
                    props.history.push("/appointmentscheduler");
                }
            }
        }
        else {
            props.history.push("/workOrderErrorPage");
        }
    };

    return (
        <>
        <HeaderJourney></HeaderJourney>
            <div className="gen_font gen_err">
                {isMobile ? (
                    <div className="mt-24-gen-head">
                        <p className="mt-gen-err gen_font">
                            {t("work_Order_Error_Message")}
                            {<span className="underline cursor-pointer" onClick={openMobiledialer} onKeyDown={openMobiledialer}> {t('phone_no')} </span>}
                        </p>
                    </div>
                ) :
                    (
                        <div className="mt-24-gen-head">
                            <p className="mt-gen-err gen_font">
                                {t("work_Order_Error_Message")}
                                {
                                    <span>
                                        {t('phone_no')}
                                    </span>
                                }
                            </p>
                        </div>
                    )}
                <div className="container">
                    <Button
                        onClick={refreshButtonHandler}
                        className="primary-btn mt-gen-err button">
                        {t("refresh_Page")}
                    </Button>
                    <Button
                        onClick={returnToHomeButtonHandler}
                        className="primary-btn mt-gen-err button">
                        {t("Return_to_Home")}
                    </Button>
                </div>
            </div>
        </>
    )
}
export default WorkOrderErrorPage;